<template>
  <button
    type="button"
    class="flex items-center justify-center rounded-full bg-background-fg/5 p-1"
  >
    <IconChevronLeft class="size-4 text-background-fg/70" />
  </button>
</template>
